module.exports = __webpack_public_path__ + "img/南海海域高精度海表温度反演系统.b6934226.png";